import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! @glint-nocheck: not typesafe yet }}\n{{! template-lint-disable no-yield-only }}\n{{yield}}")